<script >
import wantedPeopleJSONFILE from "/data/wantedPersonell.json";
import searchPerson from "@/components/SearchPerson.vue";
import axios from "axios";

export default {
  components:{
    searchPerson
  },
  data(){
    return{
     wantedPeopleList:[],
      startIndex:0,
      wantedPeopleJSON:[],
      selectedOption:null,
      sortingResults:[]
    }
  },
  props:{
    allWantedPeople:Array
  },
  methods:{

    getPeopleFromApi() {
      const websiteURL = 'https://tut-puppeteer.onrender.com';
      return axios.get(`${websiteURL}/wantedPersonell`, { timeout: 600000 });
    },
    getWantedPeople(){
      const wantedP=[];
      if(this.sortingResults.length > 1){
        for(let i=this.startIndex; i< this.startIndex +9 && i < this.sortingResults.length; i++){
          wantedP.push(this.sortingResults[i]);
        }
      }else{
        for(let i=this.startIndex; i< this.startIndex +9 && i < this.wantedPeopleJSON.length; i++){
          wantedP.push(this.wantedPeopleJSON[i]);
        }
      }

      this.startIndex +=9;
      return wantedP
    },
    handleScroll(){
      if(window.scrollY + window.innerHeight >= document.body.scrollHeight-50){
        this.wantedPeopleList = [
          ...this.wantedPeopleList, ...this.getWantedPeople()
        ];
      }
    },
    sortingSelected(){
      let returnedNames;

      if(this.selectedOption === "showAll"){
        returnedNames = this.wantedPeopleJSON
      }
      else{
         returnedNames = this.wantedPeopleJSON.filter((eventData)=>{
              if(this.selectedOption === "") return eventData
              else if (eventData.crime.toLowerCase().includes(this.selectedOption.toLowerCase())){
                return eventData;

              }
            }

        );
      }
      this.sortingResults = returnedNames;
      this.wantedPeopleList = []
      this.startIndex = 0;
      this.wantedPeopleList = this.getWantedPeople();
    }
  },


  mounted() {

      this.getPeopleFromApi()
          .then(response => {
            this.wantedPeopleJSON = response.data;
            this.wantedPeopleList = this.getWantedPeople();
            window.addEventListener("scroll", this.handleScroll);
          })
          .catch(error =>{
            console.log("using fallback data");
            this.wantedPeopleList = []
            this.wantedPeopleJSON = wantedPeopleJSONFILE;
            this.wantedPeopleList = this.getWantedPeople();


            window.addEventListener("scroll", this.handleScroll);
            console.log(error)
          } );
  }
}
</script>

<template>
  <div class="wanted-people-wrapper">
    <div class="sort-by-container">
      <span class="sort-by-span"> Sort By Crime :</span>
      <select v-model="selectedOption" @change="sortingSelected"  name="crime" id="crime">
        <option value="showAll">show all</option>
        <option value="rape">Rape</option>
        <option value="murder">Murder</option>
        <option value="assault">Assault</option>
        <option value="fraud">Fraud</option>
        <option value="robbery">Robbery</option>
        <option value="theft">Theft</option>
        <option value="shoplifting">shoplifting</option>

      </select>
      <search-person :allWantedPeople="wantedPeopleJSON" ></search-person>
    </div>
    <div class="wanted-people-description-wrap container">
      <div class="wanted-people-description-container row">

        <div class="col-lg-4 col-md-6" v-for="(wantedPerson,i) in wantedPeopleList" :key="i">
        <div class="wanted-people-card-wrapper  ">
          <div class="wanted-people-card-img">
            <img :src="`https://www.saps.gov.za/crimestop/wanted/${wantedPerson.image}`" :alt="wantedPerson.name">
          </div>
          <div class="wanted-people-card-description">
            <div class="wanted-people-names">
              <span class="span-title">Name:</span>
              <span class="span-description"> {{wantedPerson.name}} </span>
            </div>
            <div class="wanted-people-card-crime-details">
              <span class="span-title">Crime:</span>
              <span class="span-description" >{{wantedPerson.crime}}</span>

            </div>
            <div class="wanted-people-card-crime-details">
              <span class="span-title">Status:</span>
              <span class="span-description" >{{wantedPerson.status}}</span>
            </div>
            <div class="wanted-people-card-button">
              <a class="wanted-people-card-more-details-btn" :href="`https://www.saps.gov.za/crimestop/wanted/${wantedPerson.link}`">More Details</a>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>
.wanted-people-wrapper{
  padding: 5px;
  margin: 0 auto 0 auto;
}

.sort-by-span{
  color: white;
  padding-right: 4px;
}

.sort-by-container{
  padding-top: 40px;
  margin-bottom: 5px;
  text-align: center;

}

.sort-by-container select{
  padding: 5px;
  font-family: 'montserrat', sans-serif;
  margin-bottom: 10px;
}

.wanted-people-description-wrap{
  padding-top: 40px;
}

.wanted-people-card-wrapper{
  background-color: rgba(223, 41, 53, 0.39);
  padding: 15px;
  max-width: 250px;
  border-radius: 3px;
  max-height:500px ;
  margin:0 auto 20px auto;


}
.wanted-people-card-img img{
  width: 200px;
  height: 200px;
  max-width: 200px;
  color: white;
  font-weight: lighter;
}
.wanted-people-names{
  padding: 5px 0 5px 0;
  max-width: 10px;
}

.wanted-people-card-description span{
  color:white;
}



.span-title{
  padding: 0 2px 0 0;
  font-weight: bold;
}

.wanted-people-card-crime-details{
  padding: 0 0 5px 0;
}
.wanted-people-card-button{
  padding: 5px 0 0 0 ;

}
.wanted-people-card-more-details-btn{
  background-color: #00A7E1;
  text-decoration: none;
  padding: 3px 3px 3px 3px;
  border-radius: 3px;
  width: 95%;
  display: block;
  text-align: center;
  color: white;
}
</style>
